/*
 * Audible CTA click tracking — consumer shim.
 *
 * Captures clicks on any element with [data-audible-cta] and publishes
 * 'audible_click' events to Shopify.analytics + dataLayer + gtag.
 *
 * The shared chain (consent gate, pointerdown/click/auxclick capture, dedupe,
 * 3-sink publish) lives in theme/assets/cta-tracking-core.js. Per
 * rules/canonical_centralization.md this file routes through that core and
 * MUST NOT re-inline the chain.
 *
 * theme.liquid MUST load cta-tracking-core.js BEFORE this file.
 *
 * Dedupe key: cta_variant + product_id (so the same product variant
 * doesn't double-fire within 500ms across pointerdown + click events).
 *
 * Custom Pixels in Admin → Settings → Customer Events run in a sandboxed
 * iframe and receive events from the Shopify.analytics.publish path ONLY via
 * their own analytics.subscribe('audible_click', ...) registered against the
 * sandbox API — that subscription is the SOLE live path to GA4. The dataLayer
 * + gtag sinks in cta-tracking-core.js do NOT reach GA4 in page context:
 * page-context gtag was removed 2026-05-09, so no page-context gtag/GTM
 * consumer exists. A new cta-core event with no matching pixel subscription
 * fires silently into a dead sink (see rules/cookie_consent_convention.md
 * "Adding a new cta-tracking-core.js event needs a pixel subscription too").
 */
(function () {
  'use strict';

  if (!window.NCCtaTracking) {
    if (window.console) console.warn('[audible-tracking] cta-tracking-core.js not loaded; tracker disabled');
    return;
  }

  window.NCCtaTracking.install({
    attr: 'data-audible-cta',
    eventName: 'audible_click',
    idempotencyFlag: '__ncAudibleTrackingLoaded',
    logPrefix: 'audible-tracking',
    dedupeKeyFn: function (el) {
      return el.getAttribute('data-audible-cta') + '|' + (el.getAttribute('data-product-id') || '');
    },
    extraPayload: function (el) {
      var base = {
        product_id: el.getAttribute('data-product-id') || null,
        product_handle: el.getAttribute('data-product-handle') || null,
        product_title: el.getAttribute('data-product-title') || null,
      };
      // Generic N-way experiment pair (collection-hub + any future generic
      // experiment) via the canonical registry — the canonical global-tracker
      // pattern in docs/_DOC_EXPERIMENT_LAYOUT_SYSTEM.md § Key-discovery. This is
      // the numerator tag for the LIVE collection_layout A/B/C (/pages/silva):
      // active() scans the <html> exp-{key}-{variant} classes and returns [] on a
      // page with NO experiment (grid cards, articles, PDPs) — it never
      // dereferences an undefined global and never throws into
      // cta-tracking-core.js::handle(), so it is safe alongside the PDP guard
      // above. tagVariant(key, base) sets the key's SLOT dim pair — resolved via
      // window.NC_EXP_SLOTS: exp_slotK_id/exp_slotK_variant, or the legacy
      // experiment_id/experiment_variant for slot 0 (rules/experiment_slots.md).
      // (The pixel must SUBSCRIBE to forward these to GA4 — the two-part rule.)
      if (window.NCExperiments && typeof window.NCExperiments.active === 'function') {
        var running = window.NCExperiments.active();  // slot pool: MULTIPLE concurrent experiments per page-scope OK (distinct slots → distinct dim pairs)
        for (var i = 0; i < running.length; i++) {
          base = window.NCExperiments.tagVariant(running[i].key, base);
        }
      }
      return base;
    },
  });
})();
